import { render, staticRenderFns } from "./about.vue?vue&type=template&id=1c9c1b62&scoped=true"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=1c9c1b62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9c1b62",
  null
  
)

export default component.exports